import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import { memo, useEffect, useState } from "react";
import { useApiUrl } from "@refinedev/core";
import { useNavigation } from "@refinedev/core";
import { dataProvider } from "rest-data-provider";

interface Ticket {
  isOpen: boolean;
  id: string;
  handleClose: any;
}

const CloseTicket = memo(function CloseTicket(props: Ticket) {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    setOpen(props.isOpen);
  }, [props.isOpen]);

  const handleClose = (event: any, reason: any) => {
    if (reason === "escapeKeyDown" || reason === "backdropClick") return;
    props.handleClose();
  };

  const apiUrl = useApiUrl();
  const { goBack } = useNavigation();
  const continueTicket = async () => {
    await dataProvider(apiUrl).update({
      resource: "tickets",
      id: props?.id,
      variables: { status: 1 },
    });
    goBack();
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        <DialogContent>Are you sure to close this ticket?</DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button onClick={continueTicket}>CONTINUE</Button>
          <Button color="error" onClick={props.handleClose}>
            CANCEL
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
});

export default CloseTicket;
